import {BaseCaller} from './api';

export default class FCMApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    save(data: any) {
        console.log('post', data);
        return this.caller.post('fcm/', data);

    }
}



// WEBPACK FOOTER //
// ./src/api/fcm-api.ts